export interface NumericFieldResult {
  field: string;
  value: number;
}

/**
 * Extract first numeric field from a record.
 * Used by KPI components to auto-detect value field.
 *
 * If preferredField is provided and exists with a numeric value, use that.
 * Otherwise, find the first field with a numeric value.
 *
 * @param record - Record to extract numeric field from
 * @param preferredField - Optional preferred field name to check first
 * @returns NumericFieldResult with field name and value, or null if no numeric field found
 */
export function extractNumericField(
  record: Record<string, unknown>,
  preferredField?: string,
): NumericFieldResult | null {
  // Check preferred field first
  if (preferredField && preferredField in record) {
    const value = record[preferredField];
    if (typeof value === 'number') {
      return { field: preferredField, value };
    }
  }

  // Find first numeric field
  for (const [field, value] of Object.entries(record)) {
    if (typeof value === 'number') {
      return { field, value };
    }
  }

  return null;
}
